<template>
  <svg
    class="vessel-course-danger-icon"
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_7405_3027)">
      <g class="auto-cognition-frame">
        <path
          d="M0 10.8887L0 -0.000217438H10.8889V1.55534H1.55556L1.55556 10.8887H0Z"
          fill="#C95353"
          fill-opacity="0.8"
        />
        <path
          d="M10.8889 28.0005H-3.43323e-05L-3.43323e-05 17.1116H1.55552L1.55552 26.4449H10.8889V28.0005Z"
          fill="#C95353"
          fill-opacity="0.8"
        />
        <path
          d="M17.1112 0L28.0001 0V10.8889H26.4445V1.55556H17.1112V0Z"
          fill="#C95353"
          fill-opacity="0.8"
        />
        <path
          d="M28.0002 17.1116V28.0005H17.1113V26.4449H26.4446V17.1116H28.0002Z"
          fill="#C95353"
          fill-opacity="0.8"
        />
      </g>
      <g filter="url(#filter0_d_7405_3027)">
        <path
          d="M13.9998 4C12.1991 4 11.0014 5.90476 11.0014 7.40187L11.0014 22.5829C11.0014 22.8271 10.9253 23.5441 11.9008 23.8187C12.498 23.9865 13.9978 24 13.9978 24C13.9978 24 15.5017 23.9865 16.0989 23.8187C17.0757 23.5441 16.9986 22.8271 16.9986 22.5829V7.40187C16.9986 5.96825 15.8006 4 13.9998 4Z"
          fill="#D35454"
        />
      </g>
      <path
        d="M13.9605 11.1726C11.6052 11.1726 11.8114 12.6945 11.8114 13.4866C11.8114 14.2787 11.8114 21.8129 11.8114 21.8129H16.2578C16.2578 21.8129 16.2578 14.3919 16.2578 13.4866C16.2578 12.5813 16.3158 11.1726 13.9605 11.1726Z"
        fill="#FC6A6A"
      />
      <path
        d="M15.3584 15.8184H12.7745C12.7147 15.8184 12.6574 15.8407 12.6151 15.8805C12.5728 15.9203 12.549 15.9743 12.549 16.0306V19.5334C12.549 19.6809 12.6113 19.8223 12.7221 19.9266C12.8329 20.0309 12.9832 20.0895 13.1398 20.0895H14.993C15.1497 20.0895 15.3 20.0309 15.4108 19.9266C15.5216 19.8223 15.5839 19.6809 15.5839 19.5334V16.0306C15.5839 15.9743 15.5601 15.9203 15.5178 15.8805C15.4755 15.8407 15.4182 15.8184 15.3584 15.8184Z"
        fill="white"
      />
      <path
        d="M14.0664 15.2982C12.6323 15.2982 12.549 16.0432 12.549 16.0432V14.7178C12.549 14.0555 13.8146 13.9451 14.0664 13.9451C14.3183 13.9451 15.5839 14.0555 15.5839 14.7178V16.0425C15.5839 16.0425 15.5006 15.2982 14.0664 15.2982Z"
        fill="white"
      />
      <path
        d="M14.0664 16.3465C12.6323 16.3465 12.549 17.1669 12.549 17.1669V15.8404C12.549 15.2194 13.1428 14.9939 14.0664 14.9939C14.9901 14.9939 15.5831 15.2298 15.5839 15.8404V17.1669C15.5839 17.1669 15.5006 16.3465 14.0664 16.3465Z"
        fill="#0C51AF"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_7405_3027"
        x="9"
        y="3"
        width="10"
        height="24"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_7405_3027"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_7405_3027"
          result="shape"
        />
      </filter>
      <clipPath id="clip0_7405_3027">
        <rect width="28" height="28" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: "VesselCourseDangerIcon",
};
</script>
